import { render, staticRenderFns } from "./DodatnaAktivnostEdit.vue?vue&type=template&id=483e7181&scoped=true&"
import script from "./DodatnaAktivnostEdit.vue?vue&type=script&lang=js&"
export * from "./DodatnaAktivnostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e7181",
  null
  
)

export default component.exports